import React from 'react';
import styled from 'styled-components';

import SvgIcon from './svg-icon';

const Icon = styled(SvgIcon)`
    fill: #00a0d2;
`;

function Info({className}) {
    return (
        <Icon className={className} svg="information-button" />
    );
}

export default styled(Info)``;
